import styled from 'styled-components';

const SVG = styled.svg`
  display: block;

  margin-top: auto;
  margin-bottom: auto;
`;

export const Circle = styled.circle<{ disabled: boolean }>`
  stroke-width: 2;
  stroke: ${props => (props.disabled ? props.theme.colors.capsuleGray10 : props.theme.colors.capsuleGreen60)};

  ${SVG}:hover & {
    fill: ${props => (props.disabled ? 'none' : props.theme.colors.capsuleGreen60)};
  }

  ${SVG}:focus & {
    stroke: ${props => (props.disabled ? props.theme.colors.capsuleGray10 : props.theme.colors.capsuleGreen50)};
    fill: ${props => (props.disabled ? 'none' : props.theme.colors.capsuleGreen50)};
  }

  ${SVG}:active & {
    stroke: ${props => (props.disabled ? props.theme.colors.capsuleGray10 : props.theme.colors.capsuleGreen60)};
    fill: ${props => (props.disabled ? 'none' : props.theme.colors.capsuleGreen60)};
  }
`;

export const Path = styled.path<{ disabled: boolean }>`
  stroke: ${props => (props.disabled ? props.theme.colors.capsuleGray10 : props.theme.colors.capsuleGreen60)};
  fill: ${props => (props.disabled ? props.theme.colors.capsuleGray10 : props.theme.colors.capsuleGreen60)};

  ${SVG}:hover & {
    stroke: ${props => (props.disabled ? props.theme.colors.capsuleGray10 : props.theme.colors.white)};
    fill: ${props => (props.disabled ? props.theme.colors.capsuleGray10 : props.theme.colors.white)};
  }

  ${SVG}:focus & {
    stroke: ${props => (props.disabled ? props.theme.colors.capsuleGray10 : props.theme.colors.white)};
    fill: ${props => (props.disabled ? props.theme.colors.capsuleGray10 : props.theme.colors.white)};
  }

  ${SVG}:active & {
    stroke: ${props => (props.disabled ? props.theme.colors.capsuleGray10 : props.theme.colors.white)};
    fill: ${props => (props.disabled ? props.theme.colors.capsuleGray10 : props.theme.colors.white)};
  }
`;
